import React from 'react';

const Twitter = () => {
	return (
		<svg viewBox="0 0 64 64" width="32" height="32">
			<path
				strokeWidth="0"
				fill="currentColor"
				d="M60 16 L54 17 L58 12 L51 14 C42 4 28 15 32 24 C16 24 8 12 8 12 C8 12 2 21 12 28 L6 26 C6 32 10 36 17 38 L10 38 C14 46 21 46 21 46 C21 46 15 51 4 51 C37 67 57 37 54 21 Z"
			/>
		</svg>
	);
};

export default Twitter;



// WEBPACK FOOTER //
// ./src/components/icons/Twitter.js